// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

import { FooterMenuItemFragmentDoc } from './FooterMenuItem.fragment.generated';
import { FooterItemTitleFragmentDoc } from './FooterItemTitle.fragment.generated';
import { FooterItemLinkListFragmentDoc } from './FooterItemLinkList.fragment.generated';
import { LinkFragmentDoc, LinkItemFragmentDoc, PageLinkFragmentDoc, PostLinkFragmentDoc, CustomLinkFragmentDoc, LinkQuestionnaireFragmentDoc, LinkItemOpenEnquiryFormFragmentDoc, LinkItemErRecommendationsFragmentDoc } from '../../cms/index.generated';
import { FooterItemTextFragmentDoc } from './FooterItemText.fragment.generated';
import { FooterItemDividerFragmentDoc } from './FooterItemDivider.fragment.generated';
import { FooterItemWorkingHoursFragmentDoc } from './FooterItemWorkingHours.fragment.generated';
import { WorkingHoursFragmentDoc } from '../../cms/WorkingHours.fragment.generated';
export const FooterMenuFragmentDoc = `
    fragment footerMenu on FooterColumn {
  items {
    ...footerMenuItem
  }
}
    `;